var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTypeCurrency(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_2934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3974 26.1029H13.7056V23.7245C17.8381 23.5461 19.7706 20.7218 19.7706 18.0461C19.7706 13.9136 16.6786 13.0217 13.7056 12.2487V4.31079C15.9056 4.66758 17.0057 6.24325 17.2138 7.55139H19.4138C19.0869 4.90541 17.0949 2.85407 13.7056 2.52703V0H12.3974V2.49733C8.62172 2.67572 6.33252 4.93514 6.33252 8.02706C6.33252 12.0704 9.42442 12.9325 12.3974 13.7352V21.9704C9.87037 21.6136 8.74072 19.8001 8.59207 18.2244H6.36228C6.51081 21.1975 8.85957 23.3677 12.3974 23.6948V26.1029ZM17.6894 18.1353C17.6894 20.1867 16.3219 21.8813 13.7056 22.0299V14.1217C15.8759 14.7758 17.6894 15.638 17.6894 18.1353ZM8.44339 7.93784C8.44339 5.55946 10.1082 4.34054 12.3974 4.22163V11.8622C10.2272 11.2379 8.44339 10.3757 8.44339 7.93784Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_2934"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.1029,
    height: 26.1029,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTypeCurrency);
export default __webpack_public_path__ + "static/media/icon_type_currency.586c4af6fc43612e568d32c7ab6279bf.svg";
export { ForwardRef as ReactComponent };